import { useTranslation } from 'react-i18next';
import { Button } from '../../../../web/src/components/interactive/button.jsx';
import { Amount } from '../../../../web/src/components/display/amount.jsx';
import { Pill } from '../../../../web/src/components/display/pill.jsx';
import { MockAppFrame } from '../mock-app-frame.jsx';
import { useSiteLang } from '../../layout/use-site-lang.js';
import { getMockImport } from '../mock-data/mock-import.js';

const DUP_LABEL_KEY = {
	'existing': 'csvImport.dupExisting',
	'existing-possible': 'csvImport.dupExistingPossible',
};

/**
 * Bring-your-history use-case mockup: the CSV import review step, mirroring
 * the app's real preview table and reusing its csvImport strings.
 * @returns {JSX.Element}
 */
export function ImportScreen() {
	const { t } = useTranslation();
	const lang = useSiteLang();
	const { rows, symbol } = getMockImport(lang);
	const duplicates = rows.filter((row) => row.isDuplicate).length;
	return (
		<MockAppFrame url="app.thyme.money/transactions/import">
			<div className="card">
				<div className="card-header">
					<h2>{t('csvImport.previewTitle')}</h2>
				</div>
				<p className="import-hint import-preview-hint">{t('csvImport.previewHint', { duplicates })}</p>
				<div className="table-wrap">
					<table className="report-table">
						<thead>
							<tr>
								<th>{t('csvImport.colInclude')}</th>
								<th>{t('column.date')}</th>
								<th>{t('column.type')}</th>
								<th>{t('column.amount')}</th>
								<th>{t('column.description')}</th>
								<th>{t('csvImport.colStatus')}</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row, i) => (
								<tr key={i} className={!row.included ? 'row-excluded' : ''}>
									<td><input type="checkbox" checked={row.included} readOnly tabIndex={-1} /></td>
									<td>{row.date}</td>
									<td>{row.type ? t('option.' + row.type) : t('field.select')}</td>
									<td><Amount value={row.amount} decimalPlaces={0} symbol={symbol} /></td>
									<td>{row.description}</td>
									<td>
										{row.errors.length > 0 && <Pill variant="muted" className="import-flag">{t('csvImport.flagError')}</Pill>}
										{row.isDuplicate && <Pill variant="muted" className="import-flag">{t(DUP_LABEL_KEY[row.reason] ?? 'csvImport.dupExisting')}</Pill>}
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className="card-footer">
					<Button variant="ghost">{t('btn.back')}</Button>
					<Button variant="primary">{t('csvImport.confirm')}</Button>
				</div>
			</div>
		</MockAppFrame>
	);
}
